import { takeLatest } from "redux-saga/effects";

// saga and actions will be here
import * as loginAction from "../actions/login";
import * as loginSaga from "./login";

import * as budgetAction from "../actions/budget";
import * as budgetSaga from "./budget";

import * as reportAction  from "../actions/report";
import * as reportSaga from "./report";



export default function* saga() {
  // make relations like [action, saga] inside relations
 const relations = [
      [loginAction, loginSaga],
      [budgetAction, budgetSaga],
      [reportAction, reportSaga],
    ];

  for (const [actions, sagas] of relations) {
    for (const [actionName, action] of Object.entries(actions)) {
      const saga = sagas[actionName];
      if (saga) {
        yield takeLatest(action.getType(), saga);
      }
    }
  }
}
